// components/WhatsAppFloat.js
import React from 'react';
import './CSS/WhatsAppFloat.css';


const WhatsAppFloat = () => {
  const phoneNumber = "7030808025"; // Replace with your actual phone number
  const message = "Hello! I'd like to get more information about your Ali Darbar Famliy Restaurant."; // Pre-filled message

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <div className="whatsapp-icon">
        <i className="fab fa-whatsapp"></i>
      </div>
      <div className="whatsapp-tooltip">Chat with us!</div>
    </div>
  );
};

export default WhatsAppFloat;